import { connect } from 'react-redux'
import { Word } from '../../components'

const mapStateToProps = (state, ownProps) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Word)



// WEBPACK FOOTER //
// ./src/containers/Common/Word.js